import type { UserRole } from '@/types'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  roles?: UserRole[]
  children?: INavigationRoute[]
}

const studentRoutes: INavigationRoute[] = [
  {
    name: 'dashboard',
    displayName: '首页',
    meta: { icon: 'dashboard' },
  },
  {
    name: 'exercises',
    displayName: '翻译练习',
    meta: { icon: 'edit_note' },
  },
  {
    name: 'tutor',
    displayName: 'AI 导师',
    meta: { icon: 'smart_toy' },
  },
  {
    name: 'history',
    displayName: '历史记录',
    meta: { icon: 'history' },
  },
  {
    name: 'statistics',
    displayName: '统计分析',
    meta: { icon: 'analytics' },
  },
]

const teacherRoutes: INavigationRoute[] = [
  {
    name: 'dashboard',
    displayName: '首页',
    meta: { icon: 'dashboard' },
  },
  {
    name: 'exercises',
    displayName: '翻译练习',
    meta: { icon: 'edit_note' },
  },
  {
    name: 'tutor',
    displayName: 'AI 导师',
    meta: { icon: 'smart_toy' },
  },
  {
    name: 'teacher-exercises',
    displayName: '题库管理',
    meta: { icon: 'library_books' },
    roles: ['teacher', 'admin'],
  },
  {
    name: 'teacher-reviews',
    displayName: '批改审阅',
    meta: { icon: 'rate_review' },
    roles: ['teacher', 'admin'],
  },
  {
    name: 'teacher-assignments',
    displayName: '练习分配',
    meta: { icon: 'assignment_ind' },
    roles: ['teacher', 'admin'],
  },
  {
    name: 'teacher-class-profile',
    displayName: '班级画像',
    meta: { icon: 'school' },
    roles: ['teacher', 'admin'],
  },
  {
    name: 'history',
    displayName: '历史记录',
    meta: { icon: 'history' },
  },
  {
    name: 'statistics',
    displayName: '统计分析',
    meta: { icon: 'analytics' },
  },
]

const adminRoutes: INavigationRoute[] = [
  {
    name: 'dashboard',
    displayName: '首页',
    meta: { icon: 'dashboard' },
  },
  {
    name: 'exercises',
    displayName: '翻译练习',
    meta: { icon: 'edit_note' },
  },
  {
    name: 'tutor',
    displayName: 'AI 导师',
    meta: { icon: 'smart_toy' },
  },
  {
    name: 'teacher-exercises',
    displayName: '题库管理',
    meta: { icon: 'library_books' },
  },
  {
    name: 'teacher-reviews',
    displayName: '批改审阅',
    meta: { icon: 'rate_review' },
  },
  {
    name: 'teacher-assignments',
    displayName: '练习分配',
    meta: { icon: 'assignment_ind' },
  },
  {
    name: 'teacher-class-profile',
    displayName: '班级画像',
    meta: { icon: 'school' },
  },
  {
    name: 'admin-users',
    displayName: '用户管理',
    meta: { icon: 'people' },
    roles: ['admin'],
  },
  {
    name: 'history',
    displayName: '历史记录',
    meta: { icon: 'history' },
  },
  {
    name: 'statistics',
    displayName: '统计分析',
    meta: { icon: 'analytics' },
  },
  {
    name: 'settings',
    displayName: '设置',
    meta: { icon: 'settings' },
  },
]

export function getRoutesForRole(role: UserRole): INavigationRoute[] {
  switch (role) {
    case 'admin':
      return adminRoutes
    case 'teacher':
      return teacherRoutes
    default:
      return studentRoutes
  }
}

export default {
  root: {
    name: '/',
    displayName: '译了么',
  },
  routes: studentRoutes,
}
